import { useQuery, useMutation } from '@apollo/client';
import { gql } from '@apollo/client';

// GraphQL Queries and Mutations
const SEND_NOTIFICATION_TO_USER = gql`
  mutation SendNotificationToUser(
    $userIds: [Int!]
    $titleAr: String!
    $titleEn: String!
    $bodyAr: String!
    $bodyEn: String!
    $data: JSONObject!
    $imageId: Int
  ) {
    sendNotificationToUser(
      input: {
        userIds: $userIds
        title: {
          ar: $titleAr
          en: $titleEn
        }
        body: {
          ar: $bodyAr
          en: $bodyEn
        }
        data: $data
        imageId: $imageId
      }
    ) {
      success
      successCount
      failureCount
      message
    }
  }
`;

const GET_CUSTOMER_USERS = gql`
  query GetCustomerUsers {
    getCustomerUsers {
      id
      phoneNumber
      name
    }
  }
`;

// Types
export interface CustomerUser {
  id: number;
  phoneNumber: string;
  name?: string;
}

export interface NotificationTitle {
  ar: string;
  en: string;
}

export interface NotificationBody {
  ar: string;
  en: string;
}

export interface SendNotificationInput {
  userIds?: number[] | null;
  titleAr: string;
  titleEn: string;
  bodyAr: string;
  bodyEn: string;
  data: any; // Always send an object, empty {} if no data provided
  imageId?: number | undefined;
}

export interface SendNotificationResponse {
  failureCount: number;
  message: string;
  success: boolean;
  successCount: number;
}

export interface GetCustomerUsersResponse {
  getCustomerUsers: CustomerUser[];
}

// Custom Hooks
export function useGetCustomerUsers() {
  return useQuery<GetCustomerUsersResponse>(GET_CUSTOMER_USERS, {
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
  });
}

export function useSendNotificationToUser() {
  return useMutation<
    { sendNotificationToUser: SendNotificationResponse },
    SendNotificationInput
  >(SEND_NOTIFICATION_TO_USER, {
    errorPolicy: 'all',
  });
}
